import React from 'react'
import Template404 from 'src/components/template/404'

export default (props) => <Template404 location={props.location} />
